import styled from 'styled-components';

export const Wrapper = styled.main`
  position: relative;
  background: url('/page-gradient.svg') center top no-repeat;
  background-size: cover;
  flex-grow: 1;
`;
